var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.717 6.269c-.443-1.42-.068-3.075 1.105-4.248l.664-.664c1.3-1.3 3.194-1.62 4.703-.932l-3.15 3.15c-.55.55-.573 1.417-.052 1.938.52.52 1.389.497 1.938-.053l3.15-3.149c.688 1.509.369 3.402-.932 4.703l-.664.664c-1.173 1.173-2.828 1.548-4.248 1.105l-6.63 6.63a2.88 2.88 0 0 1-.856 2.113c-1.1 1.1-2.835 1.147-3.877.106-1.041-1.042-.994-2.777.106-3.877a2.88 2.88 0 0 1 2.113-.856l6.63-6.63zM1.532 16.968c.694.694 1.852.663 2.585-.07.733-.734.765-1.891.07-2.585-.694-.695-1.851-.663-2.584.07-.734.733-.765 1.89-.07 2.585z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.e6295a74f3caa58bf06589b36de05aad.svg";
export { ForwardRef as ReactComponent };